<template>
    <div>
        <div class="form-group">
            <label for="start_date">Startdatum en tijd <small class="text-danger">*</small></label>
            <input v-model="start_date" @input="set_hours()" class="form-control date-time-picker" v-bind:class="{'is-invalid' : this.errors && this.errors.start_date}" type="text" id="start_date" name="start_date">
            <small v-if="this.errors && this.errors.start_date" class="text-danger">{{ this.errors.start_date[0] }}</small>
        </div>

        <div class="form-group">
            <label for="end_date">Einddatum en tijd <small class="text-danger">*</small></label>
            <input v-model="end_date" @input="set_hours()" class="form-control date-time-picker" v-bind:class="{'is-invalid' : this.errors && this.errors.end_date}" type="text" id="end_date" name="end_date">
            <small v-if="this.errors && this.errors.end_date" class="text-danger">{{ this.errors.end_date[0] }}</small>
        </div>

        <div ref="hours_form_wrap">
            <div class="position-relative flex align-items-center mb-2">
                <label class="mb-0">Gewerkte uren gemist <small class="text-danger">*</small></label>
                <div>
                    <div class="info-circle-wrap">
                        <div class="info-circle">
                            <span class="info-text">?</span>
                        </div>
                    </div>
                    <div class="info-pop-up-wrap info-pop-up-wrap--hide">
                        <div class="info-pop-up">
                            <p class="mb-0">
                                Vul hieronder alle uren in die je contractueel gezien had moeten werken maar die je door jouw verzuim gemist hebt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex" ref="hours_wrap">
                <div v-for="(index, key) in this.old.hours" class="form-group">
                    <label :for="key">{{ key }}</label>
                    <input class="form-control w-50" v-bind:class="{'is-invalid' : errors && errors['hours.' + key]}" type="text" :id="key" :name="'hours[' + key + ']'" :value="old.hours[key]">
                    <small v-if="errors && errors['hours.' + key]" class="text-danger">{{ errors['hours.' + key][0] }}</small>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                start_date: '',
                end_date: '',
                hours: {},
                explanation: '',
                old_year_difference: 2
            }
        },
        props: {
            errors: {},
            old: {},
            hours_count_on_absence: Boolean
        },
        mounted() {
            if(Object.keys(this.old).length > 0) {
                this.type = this.old.type;
                this.start_date = this.old.start_date;
                this.end_date = this.old.end_date;
            } else {
                let start_date_default = new Date();
                start_date_default.setHours(8);
                start_date_default.setMinutes(0);
                start_date_default.setSeconds(0);

                let day = this.set_number_for_date(start_date_default.getDate());
                let month = this.set_number_for_date((start_date_default.getMonth() + 1));
                let hours = this.set_number_for_date(start_date_default.getHours());
                let minutes = this.set_number_for_date(start_date_default.getMinutes());

                let show_date = day + '-' + month + '-' + start_date_default.getFullYear() + ' / ' + hours + ':' + minutes;
                this.start_date = show_date;
                this.end_date = show_date;

                this.set_hours();
            }
        },
        methods: {
            set_number_for_date: function(number) {
                return number < 10 ? '0' + number : number;
            },
            set_hours: function () {
                let year_difference = this.end_date.substring(6,10) - this.start_date.substring(6,10);

                if(this.old_year_difference != year_difference) {
                    this.hours = {};

                    while(this.$refs['hours_wrap'].children[0]) {
                        this.$refs['hours_wrap'].children[0].remove();
                    }

                    for(let i = 0; i <= year_difference; i++) {
                        this.hours[this.start_date.substring(6,10) + i] = true;
                        this.make_hour_input(parseInt(this.start_date.substring(6,10)) + i, year_difference, i);
                    }

                    this.$refs['hours_form_wrap'].classList = year_difference > 0 ? 'mb-2 pt-2 border-top border-bottom border-primary' : '';
                    this.old_year_difference = year_difference
                }
            },
            make_hour_input: function(year, year_difference, iteration_number) {
                let form_group = document.createElement('div');
                form_group.classList = 'form-group';

                if(year_difference === iteration_number) {
                    form_group.style = 'width: ' + (100 / (year_difference + 1) - (year_difference * 5 / (year_difference + 1))) + '%';
                } else {
                    form_group.style = 'width: ' + (100 / (year_difference + 1) - (year_difference * 5 / (year_difference + 1))) + '%;margin-right: ' + 5 + '%';
                }

                this.$refs['hours_wrap'].appendChild(form_group);

                if(year_difference > 0) {
                    let label = document.createElement('label');
                    label.setAttribute('for', year);
                    label.innerHTML = 'In ' + year;
                    form_group.appendChild(label);
                }

                let input = document.createElement('input');
                input.classList = 'form-control';
                input.type = 'text';
                input.id = year;
                input.name = 'hours[' + year + ']';

                if(year_difference > 0) {
                    input.placeholder = 'In ' + year;
                } else {
                    input.placeholder = 'Gewerkte uren gemist'
                }

                form_group.appendChild(input);
            }
        }
    }
</script>
